import adminApi from '../../apis/adminApi';

export function getPaymentsService({ params, values }) {
  return adminApi.post('/api/admin/payments', values, { params }).then((res) => res.data);
}

export function getPaymentService(id) {
  return adminApi.get(`/api/admin/payments/${id}`).then((res) => res.data);
}

export function getNativeInfoService(id) {
  return adminApi.get(`/api/admin/payments/${id}/native-info`).then((res) => res.data);
}

export function sendPaymentsReportService(values) {
  return adminApi.post('/api/admin/payments/send-old-report', values).then((res) => res.data);
}

export function getPaymentSearchOptionsService() {
  return adminApi.get('/api/admin/payments/search-options').then((res) => res.data);
}

export function getPaymentStatementService(id) {
  return adminApi.get(`/api/admin/payments/${id}/statement`).then((res) => res.data);
}

export function cancelPaymentStatementService(id) {
  return adminApi.delete(`/api/admin/payments/${id}/statement`).then((res) => res.data);
}

export function getPaymentLogsService(id) {
  return adminApi.get(`/api/admin/payments/${id}/logs`).then((res) => res.data);
}

export function getPaymentCoreLogsService(id) {
  return adminApi.get(`/api/admin/payments/${id}/core-logs`).then((res) => res.data);
}

export function adminRefundPaymentService(id, values) {
  return adminApi.post(`/api/admin/payments/${id}/refund`, values).then((res) => res.data);
}
